import baseApi from "@/api/baseApi";

export default {
  addOrUpdate(form) {
    return baseApi.put('api-ear-marks/api/v1/category', form);
  },
  delete(id) {
    return baseApi.delete(`api-ear-marks/api/v1/category/${id}`);
  },
  fetch() {
    return baseApi.get(`api-ear-marks/api/v1/category`);
  },
  order(form) {
    return baseApi.post(`api-ear-marks/api/v1/order`, form);
  },
  addToOrderSet() {
    return baseApi.put(`api-ear-marks/api/v1/order-set`);
  },
  fetchOrderSetById(id) {
    return baseApi.get(`api-ear-marks/api/v1/order-set/${id}`);
  },
  fetchOrderSetByReportData(id) {
    return baseApi.get(`api-ear-marks/api/v1/order-set/${id}/report-data`);
  },
}
